// extracted by mini-css-extract-plugin
export default {"container":"nUN82wgw3u67YaYnHMwX","priceTarget":"xhfL6N3J6Kk8CxGCBkzQ","priceTargetValue":"xEQbHoWSkTMzz0OFHSox","headline":"WWs1SPMm0xcEWEa4Vw1H","dimmed":"buTzhD5E72nFliWJzZ0A"};